import React from "react";
import { graphql } from "gatsby";
import { Helmet } from 'react-helmet'


export const query = graphql`
  query RedirectQuery($redirectId: ID!) {
    strapi {
        redirect( id: $redirectId ) {
            id
            old_path
            new_path
      }
    }
  }
`;

const RedirectPage = ( {data} ) => {
  const thisPage = data.strapi.redirect

  return (
    <>
        <Helmet>
            <title>Redirected</title>
            <meta http-equiv="refresh" content={"0; url="+thisPage.new_path} />
        </Helmet>

        <p>The page {thisPage.old_path} has moved to: 
            <a href={thisPage.new_path}>{thisPage.new_path}</a></p>
        <script type="text/javascript">
            {"window.location.replace("+thisPage.new_path+");"}
        </script>
    </>
  );
};

export default RedirectPage;
